<template>
  <div class="week">
    <day
      v-for="day in days"
      :key="day"
      :active-date-filter="activeDateFilter"
      :is-iframe="isIframe"
      :is-full-width="isFullWidth"
      :day="day"
      @addToFilters="addToFilters($event.key, $event.value)"
      @removeFilter="removeFilter($event)"
      @loadCourseResults="populateCalendar($event)"
    />
  </div>
</template>
<script>
  import Day from './day';

  export default {
    components: {Day},
    props: {
      days: {
        required: true,
        type: Array,
      },
      activeDateFilter: {
        required: false,
        type: String,
        default: undefined,
      },
      isIframe: {
        type: Boolean,
        required: false,
      },
      isFullWidth: {
        type: Boolean,
        required: false,
      },
    },
    methods: {
      populateCalendar(filters) {
        this.$emit('loadCourseResults', filters);
      },
      addToFilters(key, value) {
        this.$emit('addToFilters', {key: key, value: value});
      },
      removeFilter(key) {
        this.$emit('removeFilter', key);
      },
    },
  };
</script>
